import { render, staticRenderFns } from "./SharedAlbums.vue?vue&type=template&id=2d5a57ea&scoped=true&"
import script from "./SharedAlbums.vue?vue&type=script&lang=js&"
export * from "./SharedAlbums.vue?vue&type=script&lang=js&"
import style0 from "./SharedAlbums.vue?vue&type=style&index=0&id=2d5a57ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a57ea",
  null
  
)

export default component.exports